import { useEffect } from 'react';
import { cx } from './primitives.tsx';

/**
 * Marca Pure Layout.
 *
 * O monograma é a imagem oficial (recortada de `sem fundo.png`, a versão
 * transparente do logo): o degradê ciano→azul é dele, e redesenhá-lo à mão
 * seria uma segunda versão da marca. O nome é texto em Sora, e não imagem,
 * para ficar nítido em qualquer tamanho e legível por leitor de tela.
 */
export function Logo({
  size = 28,
  showName = true,
  tone = 'night',
  product,
}: {
  size?: number;
  showName?: boolean;
  /** `night`: sobre o marinho. `paper`: sobre fundo claro (proposta impressa). */
  tone?: 'night' | 'paper';
  /** Linha abaixo do nome — o produto dentro da marca ("Prospector"). */
  product?: string;
}) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <img
        src={size > 48 ? '/brand/pl-mark-192.png' : '/brand/pl-mark-96.png'}
        alt={showName ? '' : 'Pure Layout'}
        width={Math.round(size * (554 / 473))}
        height={size}
        style={{ height: size, width: 'auto' }}
        className="shrink-0 select-none"
        draggable={false}
      />
      {showName && (
        <span className="flex flex-col leading-none">
          <span
            className={cx(
              'font-display text-[15px] font-semibold tracking-[0.02em]',
              tone === 'night' ? 'text-white' : 'text-[var(--color-ink)]',
            )}
          >
            Pure Layout
          </span>
          {product && (
            <span
              className={cx(
                'mt-1 text-[11px] font-medium',
                tone === 'night' ? 'text-[var(--color-cyan)]' : 'text-[var(--color-brand)]',
              )}
            >
              {product}
            </span>
          )}
        </span>
      )}
    </span>
  );
}

/** "Prospects · Prospector": a aba do navegador diz onde se está. */
export function useDocumentTitle(title: string | undefined) {
  useEffect(() => {
    document.title = title ? `${title} · Prospector` : 'Prospector · Pure Layout';
  }, [title]);
}
